function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l5 5 5-5H0z",
  fill: "#5F6368"
});

var SvgSelectArrow = function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEwIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMCAwTDUgNUwxMCAwSDBaIiBmaWxsPSIjNUY2MzY4Ii8+Cjwvc3ZnPgo=";
export { SvgSelectArrow as ReactComponent };